export default __webpack_public_path__ + "static/media/priestofmitra.4e4e04aa.png";